/* global axios */
import ApiClient from './ApiClient';

class CommercialWidgetsAPI extends ApiClient {
  constructor() {
    super('commercial_widgets', { accountScoped: true, apiVersion: 'v2' });
  }

  list() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, { commercial_widget: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, { commercial_widget: payload });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reorder(positions) {
    return axios.patch(`${this.url}/reorder`, { positions });
  }

  getData(id, params) {
    return axios.get(`${this.url}/${id}/data`, { params });
  }

  getCatalog() {
    return axios.get(`${this.url}/catalog`);
  }
}

export default new CommercialWidgetsAPI();
